import { isServer } from '../utils/utils';

export enum EventLocation {
    'widget',
    'cart',
}

export enum EventAction {
    'widget-view',
    'widget-click',
    'widget-add',
}

export type EventData = {
    widgetResponseId: string;
    customerQuery?: string;
    widgetId: string;
    widgetType: string;
    metadataType: string;
    itemId?: string;
    sku?: string;
};

export type Event = {
    location: EventLocation;
    action: EventAction;
    data: EventData;
};

export const WIDGET_TYPE = {
    item: 'item',
    category: 'category',
    global: 'global',
    brandCategory: 'brandCategory',
    collectionCategory: 'collectionCategory',
};

const WIDGET_MAP = {
    [WIDGET_TYPE.item]: 'item',
    [WIDGET_TYPE.category]: 'category',
    [WIDGET_TYPE.global]: 'global',
    [WIDGET_TYPE.brandCategory]: 'category',
    [WIDGET_TYPE.collectionCategory]: 'category',
};

export const useBloomreach = () => {
    const BrTrk = isServer ? null : (window.BrTrk ?? null);
    const tracker = BrTrk?.getTracker();

    const widgetRendered = (event: Event): void => {
        const { location, action, data } = event;

        if (BrTrk && tracker) {
            tracker.logEvent(
                EventLocation[location],
                EventAction[action],
                {
                    wrid: data.widgetResponseId,
                    wq: data.customerQuery,
                    wid: data.widgetId,
                    wty: data.metadataType ?? WIDGET_MAP[data.widgetType],
                },
                true,
            );
        }
    };

    const widgetClicked = (event: Event): void => {
        const { location, action, data } = event;
        if (BrTrk && tracker) {
            tracker.logEvent(
                EventLocation[location],
                EventAction[action],
                {
                    wrid: data.widgetResponseId,
                    wq: data.customerQuery,
                    wid: data.widgetId,
                    wty: data.metadataType ?? WIDGET_MAP[data.widgetType],
                    item_id: data.itemId,
                    sku: data.sku,
                },
                true,
            );
        }
    };

    return { widgetRendered, widgetClicked };
};
